// Importación de imágenes SVG
import add_plus from "./svg/add_plus.svg";
import check from "./svg/check.svg";
import error from "./svg/error.svg";
import exclamacion_amarillo from "./svg/exclamacion_amarillo.svg";
import exclamation_triangle from "./svg/exclamation-triangle.svg";
import eye_regular from "./svg/eye-regular.svg";
import eye_slash from "./svg/eye-slash-regular.svg";
import information from "./svg/information.svg";
import phone from "./svg/phone.svg";
import trash from "./svg/trash.svg";
import cellphone_security from "./svg/pin/cellphone_security.svg";
import circle_green_check from "./svg/pin/circle_green_check.svg";
import circle_red_check from "./svg/pin/circle_red_check.svg";
import pin_phone from "./svg/pin/phone.svg";
import question from "./svg/bi-question-circle-fill.svg";
import not_found from "./svg/not_found.svg";

// Agrupación de imágenes en un objeto
const images = {
    add_plus,
    check,
    error,
    exclamacion_amarillo,
    exclamation_triangle,
    eye_regular,
    eye_slash,
    information,
    phone,
    trash,
    cellphone_security,
    circle_green_check,
    circle_red_check,
    pin_phone,
    question,
    not_found
};

export default images;
